import overrides from './overrides';
import styles from './styles';
import config from './config';
import modules from './modules';
import routes from './routes';
import { getNavigation } from './navigation';

const configuration = {
  overrides,
  styles,
  config,
  modules,
  getNavigation,
  routes,
};

export default configuration;
